import * as React from 'react'
import { Image, Header } from 'semantic-ui-react'

const gigi = '//res.cloudinary.com/danrx4fes/image/upload/c_lpad,w_150,h_200/gilda'

const History = () => (
  <div>
    <Header size='large'>G&A Arquitetura e Engenharia</Header>
    <p>
      Fundada em 1992, desde então atua no desenvolvimento projetos corporativos, comercial e industrial, distribuídos por todo Brasil. 
    </p>
    <p>
      Com especialidade em Projetos para Centros de Controle Operacional (CCO) e Centros de Controle Integrado (COI) nas áreas de mineração, refinaria, transporte, rodovias, entre outras, busca através de uma metodologia de trabalho eficiente atender com rigor prazos e custos planejados. 
    </p>
    <p>
      Focada na sustentabilidade tem como preocupação constante nos projetos os requisitos de ergonomia, funcionalidade, estética e eficiência energética, resultando em soluções inovadoras no que há de mais avançado no campo tecnológico.
    </p>
    <Header size='medium'>Gilda Vivacqua de Alencar</Header>
    <div>
      <Image src={gigi} size='small' floated='right' />
      <p>
      Arquiteta e Urbanista graduada em 1983 pela Universidade Santa Úrsula, Rio de Janeiro / RJ, com especialização em Gestão Empresarial para Escritórios de Arquitetura e Design, pela FGV. 
      </p>
      <p>
        Atua desde 1992 como titular na G&A Arquitetura e Engenharia, desenvolvendo projetos de Centros de Controle Operacional (CCO), Centros de Controle Integrado (COI) para empresas de grande porte das áreas de mineração, transportes, refinarias e de Centro Integrado de Comando e Controle (CICC) para gestão municipal.
      </p>
      <p>
        Dentre os projetos realizados destacam-se: CCO do Complexo de Carajás/PA – ABB/VALE, COI GLOBAL/MG – EY/VALE, CCO do Metrô Rio/RJ e CCO da LAMSA/RJ – Grupo INVEPAR, CCO da SUPERVIA Trens Urbanos/RJ, CCO da ALUNORTE/PA e o CICC da Prefeitura Municipal de Santos.
      </p>
    </div>
  </div>
)

export default History
